import React from 'react'
import { Grid, Box, Heading, Text, Skeleton } from '@chakra-ui/core'
import { ImageBox } from '@engyalo/storefront-components'
import { ICollectionProduct } from '@engyalo/storefront-types'
import format from 'number-format.js'

export function HorizontalProduct({
  product,
  currency,
  currencyPrefix,
  currencyFormat,
  cart,
  showPrice,
  isLoading,
  ...props
}: ICollectionProduct) {
  const quantity = Object.entries(cart).reduce(
    (prev, [key, cartItem]) => (key.includes(product.id ?? '') ? prev + (cartItem?.quantity ?? 0) : prev),
    0
  )

  return (
    <Grid gridTemplateColumns="1fr 3fr" borderY="1px solid #F1F1F1" p="1rem">
      <Box>
        <Skeleton isLoaded={!isLoading} w="100%" h={isLoading ? '7rem' : 'unset'}>
          <ImageBox imageUrl={(product.imageURL || [])[0] || ''} quantity={quantity} />
        </Skeleton>
      </Box>
      <Box ml="8">
        <Skeleton
          isLoaded={!isLoading}
          w={isLoading ? '40%' : 'unset'}
          h={isLoading ? '1.6rem' : 'unset'}
          flex={isLoading ? 'unset' : '1'}
          marginY=".4rem"
        >
          <Heading as="h3" size="sm">
            {product.name}
          </Heading>
        </Skeleton>
        <Text fontFamily="body" color="gray.100" my="2">
          {product.description}
        </Text>
        <Skeleton
          isLoaded={!isLoading}
          w={isLoading ? '100%' : 'unset'}
          h={isLoading ? '1.6rem' : 'unset'}
          paddingBottom=".4rem"
        >
          <Text fontFamily="body" color="gray.100" my="2">
            {product.description}
          </Text>
        </Skeleton>
        {showPrice && (
          <Skeleton
            isLoaded={!isLoading}
            w={isLoading ? '40%' : 'unset'}
            h={isLoading ? '1.6rem' : 'unset'}
            flex={isLoading ? 'unset' : '1'}
            marginY=".4rem"
          >
            <Text fontFamily="body" fontSize="md" color="primary.500">
              {`${currencyPrefix} ${format(currencyFormat, product.price || 0)} ${currency}`}
            </Text>
          </Skeleton>
        )}
      </Box>
    </Grid>
  )
}
